import { useQuery } from "@tanstack/react-query";
import { getAuditDatas, getSensitivityAuditDatas } from "../../api/audit";

export const AUDIT_QUERY_KEY = ["audit"] as const;

export function useAuditData(
  entityId: number,
  entityType: string,
  computeGeneration?: number,
) {
  return useQuery({
    queryKey: [...AUDIT_QUERY_KEY, entityType, entityId, computeGeneration],
    queryFn: () =>
      entityType === "sensitivity"
        ? getSensitivityAuditDatas(entityId)
        : getAuditDatas(entityId),
    enabled: entityId > 0,
    staleTime: 0,
  });
}
